'use client';

import EditorImg from 'lowcode/components/EditorImg';
import IconRight from './IconRight';
import { tranText } from './tranText';
import TimeComp from './TimeComp';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { formatPoints } from '@/components/MembersDay/utils';
import { signupCookie } from '@/utils/cookies/signupCookie';

export default function ListCard({ data = {}, creditsData = {}, itemCallback, tabType, locale }: any) {
    const textObj = tranText[locale] || tranText['us'];
    const num1 = parseFloat(data?.points || '0');
    const num2 = parseFloat(creditsData?.points || '0');
    const { isLogin } = useMembersStore();
    const isDisabled = isLogin && num1 > num2;

    // 打开介绍
    const openItemHandle1 = () => {
        itemCallback && itemCallback('open', data, false, tabType);
    };
    // 打开兑换
    const openItemHandle2 = () => {
        if (!isLogin) {
            const pathname2 = location.pathname;
            signupCookie?.({
                sector_name: data?.goodTitle || textObj.card_discount_code,
                entry_postion: 4,
            });
            location.href = `/${locale}/login?redirect=${pathname2}`;
            return;
        }
        if (isDisabled) {
            return;
        }
        itemCallback && itemCallback('open', data, true, tabType);
    };

    return (
        <>
            <div className="eco-redeem-rewards-card">
                <div className="eco-redeem-rewards-card-img">
                    {data.rulePic && <EditorImg pc={data.rulePic} />}
                    <div className="eco-redeem-rewards-card-amount">
                        <div className="eco-redeem-rewards-card-amount-l">
                            <div className="eco-redeem-rewards-card-amount-line1">
                                <span className="eco-redeem-rewards-card-amount-line1-a">{data?.ruleWebsite?.amount}&nbsp;</span>
                                <span className="eco-redeem-rewards-card-amount-line1-b">{data?.ruleWebsite?.currencySymbol}</span>
                            </div>
                            <div className="eco-redeem-rewards-card-amount-line2">{textObj?.card_off}</div>
                        </div>
                        {data?.prerequisiteRange && (
                            <div className="eco-redeem-rewards-card-amount-r">
                                {textObj?.card_price_tips}&nbsp;(
                                {['uk', 'eu'].includes(locale)
                                    ? `${data?.ruleWebsite?.currencySymbol} ${data?.prerequisiteRange}`
                                    : `${data?.prerequisiteRange} ${data?.ruleWebsite?.currencySymbol}`}
                                )
                            </div>
                        )}
                    </div>
                </div>
                <div className="eco-redeem-rewards-card-desc">
                    <div className="eco-redeem-rewards-card-desc1">{data?.goodTitle || textObj.card_discount_code}</div>
                    <div className="eco-redeem-rewards-card-desc2">
                        {formatPoints(data?.points, locale)}&nbsp;
                        {textObj.card_credits}
                    </div>
                </div>
                <div className="eco-redeem-rewards-card-note">
                    <div className="eco-redeem-rewards-card-note-l" onClick={openItemHandle1}>
                        {textObj.card_rules}
                    </div>
                    <div className="eco-redeem-rewards-card-note-r" onClick={openItemHandle1}>
                        <IconRight />
                    </div>
                </div>
                <TimeComp targetTime={data.campaignEndTime} />
                <div className="eco-redeem-rewards-card-btns">
                    <div className={`eco-redeem-rewards-card-btn ${isDisabled ? ' eco-redeem-rewards-card-btn-disabled' : ''}`} onClick={openItemHandle2}>
                        {textObj.card_btn}
                    </div>
                </div>
            </div>
        </>
    );
}
